import { TaskIsCompletedNotification } from "#/store/types";
import { constructURLToTask } from "#/util";
import React from "react";
import style from "./index.module.scss";
import ItemWrapper from "./ItemWrapper";
import { DerivedNotificationItemProps } from "./types";

const TaskIsCompletedNotificationItem = React.forwardRef(
  (props: DerivedNotificationItemProps<TaskIsCompletedNotification>, ref: React.Ref<any>) => (
    <ItemWrapper
      ref={ref}
      onClick={() => {
        props.push(constructURLToTask(props.notification.task_model));
      }}
      notification={props.baseNotification}
    >
      <span className={style["notification-menu-item__text"]}>
        Задача {`"${props.notification.task_model.name}"`} выполнена
      </span>
    </ItemWrapper>
  ),
);

export default TaskIsCompletedNotificationItem;
